var API = {
  url: '/api/',
  version() {
    var url = new URL(window.location);
    var searchParams = new URLSearchParams(url.search.substring(1));
    // сейчас в любом случае Shop
    return 'Shop';
  },

  complete(params) {
    if (!('notFoundRedirect' in params)) params.notFoundRedirect = true;
    if (!('unauthorizedReload' in params)) params.unauthorizedReload = true;

    return (xhr) => {
      let response;
      try {
        response = JSON.parse(xhr.responseText);
      } catch (e) {
        response = xhr.responseText;
      }

      const errorPopup = () => {
        const msg =
          typeof response === 'string'
            ? response
            : (response ? JSON.stringify(response) : '');

        popups.create({
          style: 'popup-danger',
          title: 'Ошибка',
          text: (!msg || msg.trim() === '')
            ? 'Ошибка соединения с сервером'
            : msg,
          timeout: 2000
        });
      };

      const status = xhr.status;

      // ВАЖНО: 200 обрабатываем в settings.success (иначе можно случайно задвоить)
      switch (status) {
        case 401:
          if (params.unauthorizedReload) {
            localStorage.removeItem('shop24');
            localStorage.removeItem('shop24_permissions');
            localStorage.removeItem('shop24_cookie');
            localStorage.removeItem('shop24_user');
            localStorage.removeItem('shop24_main_user');
            window.location.reload(true);
          }
          break;

        case 404:
          if (params.notFoundRedirect) observable.trigger('not-found');
          break;

        case 500:
          errorPopup();
          if (params.error) params.error(response, xhr);
          break;

        default:
          // для всех не-200
          if (status !== 200) {
            errorPopup();
            if (params.error) params.error(response, xhr);
          }
          break;
      }

      if (params.complete) params.complete(response, xhr);
    };
  },

  request(params) {
    var settings = {};

    if (!params.object) throw new Error('"Object" parameter is required');
    if (!params.method) throw new Error('"Method" parameter is required');

    settings.crossDomain = true;
    settings.xhrFields = { withCredentials: true };

    settings.url = `${this.url}${this.version()}/${params.object}/${params.method}/`;
    settings.method = 'POST';

    settings.beforeSend = params.beforeSend || function (request) {
      request.setRequestHeader("Secookie", params.cookie || localStorage.getItem('shop24_cookie'));
    };

    // ✅ JSON как JSON
    if (params.data !== undefined) {
      settings.data = JSON.stringify(params.data);
      settings.contentType = 'application/json; charset=UTF-8';
      settings.processData = false;
    }

    settings.dataType = 'json';

    // ✅ успех обрабатываем тут
    settings.success = function (response, textStatus, xhr) {
      if (response && response.noticeCount) {
        response.noticeCount.forEach(item => {
          if (item.object) {
            $(`.notice-count-${item.object}`).text(item.count);
          }
        });
      }
      if (params.success) params.success(response, xhr);
    };

    settings.complete = this.complete(params);

    return $.ajax(settings);
  },

  requestCMS(params) {
    var settings = {};

    if (!params.object) throw new Error('"Object" parameter is required');
    if (!params.method) throw new Error('"Method" parameter is required');

    settings.crossDomain = true;
    settings.xhrFields = { withCredentials: true };

    settings.url = `${this.url}2_dev/CMS/${params.object}/`;
    settings.method = params.method;

    settings.beforeSend = params.beforeSend || function (request) {
      request.setRequestHeader("Secookie", params.cookie || localStorage.getItem('shop24_cookie'));
    };

    // ✅ JSON как JSON
    if (params.data !== undefined) {
      settings.data = JSON.stringify(params.data);
      settings.contentType = 'application/json; charset=UTF-8';
      settings.processData = false;
    }

    settings.dataType = 'json';
    settings.complete = this.complete(params);

    // если нужен success коллбек
    if (params.success) {
      settings.success = function (response, textStatus, xhr) {
        params.success(response, xhr);
      };
    }

    return $.ajax(settings);
  },

  upload(params) {
    var settings = {};

    if (!params.data) throw new Error('"Data" parameter is required');

    if (!params.object)
      settings.url = `${this.url}${this.version()}/Image/?section=${params.section}`;
    else
      settings.url = `${this.url}${this.version()}/${params.object}`;

    settings.method = 'POST';
    settings.data = params.data;
    settings.cache = false;
    settings.processData = false;
    settings.contentType = false;
    settings.dataType = 'json';

    settings.crossDomain = true;
    settings.xhrFields = { withCredentials: true };

    settings.beforeSend = (request) => {
      request.setRequestHeader("Secookie", params.cookie || localStorage.getItem('shop24_cookie'));
    };

    if (params.progress) {
      settings.xhr = function () {
        var xhr = $.ajaxSettings.xhr();
        xhr.upload.addEventListener('progress', function (e) {
          if (e.lengthComputable) params.progress(e);
        }, false);
        return xhr;
      };
    }

    if (params.success) {
      settings.success = function (response, textStatus, xhr) {
        params.success(response, xhr);
      };
    }

    settings.complete = this.complete(params);
    return $.ajax(settings);
  },

  download(params) {
    if (!params.object) throw new Error('"Object" parameter is required');
    if (!params.method) throw new Error('"Method" parameter is required');

    var xhr = new XMLHttpRequest();

    // ✅ добавил method в URL (как в request)
    xhr.open('POST', `${this.url}${this.version()}/${params.object}/${params.method}/`, true);
    xhr.withCredentials = true;
    xhr.responseType = 'arraybuffer';

    xhr.setRequestHeader("Secookie", params.cookie || localStorage.getItem('shop24_cookie'));

    xhr.onload = function () {
      if (this.status === 200) {
        var filename = '';

        var disposition = xhr.getResponseHeader('Content-Disposition');
        if (disposition && disposition.indexOf('attachment') !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
        }

        var type = xhr.getResponseHeader('Content-Type');
        var blob = new Blob([this.response], { type: type });

        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          var URL_ = window.URL || window.webkitURL;
          var downloadUrl = URL_.createObjectURL(blob);

          if (filename) {
            var a = document.createElement('a');
            if (typeof a.download === 'undefined') {
              window.location = downloadUrl;
            } else {
              a.href = downloadUrl;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
            }
          } else {
            window.location = downloadUrl;
          }

          setTimeout(() => { URL_.revokeObjectURL(downloadUrl); }, 100);
        }
      }
    };

    // ✅ JSON как JSON
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    xhr.send(JSON.stringify(params.data || {}));
  },

  authCheck(params) {
    if (localStorage.getItem('shop24_cookie') == null) return;

    let settings = {};
    let _this = this;

    $.ajax({
      url: './config.json',
      dataType: 'json',
      success(response) {
        settings.url = `${response.data.hostApi}/api/Auth/`;
        _this.url = `${response.data.hostApi}/api/`;

        settings.method = 'GET';
        settings.crossDomain = true;
        settings.xhrFields = { withCredentials: true };

        settings.beforeSend = (xhr) => {
          xhr.setRequestHeader("Secookie", params.cookie || localStorage.getItem('shop24_cookie'));
        };

        settings.complete = (xhr) => {
          let resp;
          try { resp = JSON.parse(xhr.responseText); }
          catch (e) { resp = xhr.responseText; }

          let status = xhr.status;
          switch (status) {
            case 200:
              if (params && typeof params.success === 'function') params.success(resp, xhr);
              break;
            case 401:
              if (params && typeof params.error === 'function') params.error(resp, xhr);
              break;
          }
        };

        return $.ajax(settings);
      }
    });
  }
};

if (process.env.NODE_ENV === 'development') window.API = API;

module.exports = API;

if (module.hot) module.hot.accept();



// WEBPACK FOOTER //
// ./scripts/api.js